// PWA service-worker registration. Safe-fails in unsupported browsers,
// in HTTP contexts, and in development hot-reload (we still register in
// dev so push/notif flows can be exercised against the preview URL —
// the SW just won't survive frequent rebuilds).
import { logger } from "./logger";

let registrationPromise = null;

export function registerServiceWorker() {
    if (typeof window === "undefined") return Promise.resolve(null);
    if (!("serviceWorker" in navigator)) return Promise.resolve(null);
    if (registrationPromise) return registrationPromise;
    registrationPromise = navigator.serviceWorker
        .register("/sw.js", { scope: "/" })
        .then((reg) => {
            logger.info("[pwa] service worker registered, scope:", reg.scope);
            return reg;
        })
        .catch((err) => {
            logger.warn("[pwa] service worker registration failed", err);
            return null;
        });
    return registrationPromise;
}

export async function getServiceWorkerReady() {
    if (!("serviceWorker" in navigator)) return null;
    try {
        return await navigator.serviceWorker.ready;
    } catch (e) {
        logger.warn("[pwa] service worker not ready", e);
        return null;
    }
}
